import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'react-bootstrap';
import toastr from 'toastr';
import SweetAlert from 'react-bootstrap-sweetalert';
import $ from 'jquery';
import Dialog from 'material-ui/Dialog';

/* Function */
import ObjGeneral from '../../containers/function';
import Constants from '../../containers/function/constants.js';
import EventTracker from '../../containers/function/eventTracker';

/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as tasksManagerTabTasksActions from '../../actions/tasks_manager_tab_tasks/index';
import * as dashboardActions from '../../actions/dashboard/index.js';
import * as headerActions from '../../actions/header/index.js';

/* Components */
import ButtonsTop from './buttonsTop';
import TopCharts from './topCharts';
import Filters from './filters';
import TasksTable from './tasksTable';
import TaskModal from './taskModal';
import Loading from '../common/loading';
import Message from '../common/message';
import Expired from '../../containers/expired/index';
import tourConfig from '../common/tour/config';
import tourSteps from './tourSteps';
import HtmlPopupModal from './htmlPopupModal';

export class TasksManagerTabTasks extends Component {
  constructor(props) {
    super(props);

    // component is assigned to the windows object to be able to use the methods in other components
    window._TasksManagerTabTasks = this;
    this.eventTracker = new EventTracker();

    this.state = {
      pag:1,
      paramTask: props.params.id_task,
      sort: {
        OccurrenceDate: null,
        CreatedDate: "DESC",
        ClosedDate: null,
        TaskType: null,
        Subtype: null,
        Person: null,
        Vehicle: null,
        Accountable: null,
        Manager: null
      },
      annulStateMap: {},
      showModal: false,
      showConfirmAnnul: false,
      showConfirmAnnulSingle: false,
      showConfirmAnnulSingleAction: null,
      showDriverError: false,
      showDriverErrorAlias: "",
      firstOpen: true,
      isTourOpen: null,
      modalHtmlPopup: false,
      modalHtmlPopupData: {
        title: null,
        htmlDetail: null
      },
      showErrorDownload: false,
    };
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideModal, false);
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('task');

    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        const rootUser = localStoreFN().getItem('root');

        if (obj.generalSetting.views.includes('task')) {
          // gets the filters from the TaskManager component (parent of the tabs)
          const dateStart = this.props.filtersTaskManager.date.fechaStartFinal || null;
          const dateEnd = this.props.filtersTaskManager.date.fechaEndFinal || null;
          const tags = this.props.filtersTaskManager.tags;
          const personId = this.props.filtersTaskManager.personId || null;
          const type = this.props.filtersTaskManager.type || null;
          const subtype = this.props.filtersTaskManager.subtype || null;

          if(obj.taskManager.showOccurrenceDateExceptForAdminUsers || rootUser=="true") {
            this.state.sort.OccurrenceDate = "DESC";
            this.state.sort.CreatedDate = null;
          }

          // filters only deviations that are of type Tasks
          this.props.filters.otherFilters.showDeviationsOrNotifications = "OnlyDeviations";

          this.props.actions.setFilterTasksManager({
            otherFilters: this.props.filters.otherFilters
          });

          // call to Form's fetch api
          await this.props.actions.fetchTasksManagerApi({
            dateStart,
            dateEnd,
            tags,
            personId,
            type,
            subtype,
            otherFilters: this.props.filters.otherFilters,
            sort: this.state.sort,
            pag: this.state.pag
          });

          await this.props.actions.fetchTasksManagerCountApi({
            dateStart,
            dateEnd,
            tags,
            personId,
            type,
            subtype,
            otherFilters: this.props.filters.otherFilters
          });

          this.props.headerActions.setRepeatTourAction(this.openTour);
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }

    document.addEventListener('mousedown', this.handleClickOutsideModal, false);
  }

  handleSubmit = async obj => {
    const format = this.props.language.account.date.format;
    const tags = (obj.multipleTagsInputIsMultiple) ? ObjGeneral.getTags(obj) : this.props.filtersTaskManager.tags;
    const date = ObjGeneral.getDate(obj, format);
    const personId = ObjGeneral.getPersonId(obj, this.props.filtersTaskManager.datos.persons);
    const { type, subtype } = ObjGeneral.getTypeSubtype(obj, this.props.filtersTaskManager.datos.types);
    let otherFilters = ObjGeneral.cloneObject(this.props.filters.otherFilters);

    if(obj.target && obj.target.dataset.selectfilter) {
      otherFilters[obj.target.dataset.selectid] = obj.target.dataset.value;
      if(obj.target.dataset.selectid=="type") {
        otherFilters["subtype"] = "";
      }
    }

    this.setState({
      pag: 1,
      annulStateMap: {}
    });

    this.props.actions.setFilterTasksManager({
      otherFilters: otherFilters
    });

    await this.props.actions.fetchTasksManagerApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags,
      personId,
      type,
      subtype,
      otherFilters: otherFilters,
      sort: this.state.sort,
      pag: 1
    });

    await this.props.actions.fetchTasksManagerCountApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags,
      personId,
      type,
      subtype,
      otherFilters: otherFilters
    });
  };

  openTour = () => {
    this.setState({
      isTourOpen: true
    });
  };

  closeTour = async () => {
    const viewedTours = localStoreFN().getItem('viewedTours');
    const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.taskManager] : false;

    if(tourComplete==false) {
      await this.props.dashboardActions.setTourViewed({tourName:Constants.toursKeys.taskManager});
    }

    this.setState({
      isTourOpen: false
    });
  };

  async componentDidUpdate(prevProps, prevState) {
    if(!this.props.loading
        && this.props.status === 200 && this.props.statusTags === 200
        && this.state.firstOpen==true) {
      const viewedTours = localStoreFN().getItem('viewedTours');
      const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.taskManager] : false;
      // tour load when the sight just enters
      this.state.firstOpen = false;
      if(tourComplete==false) {
        this.state.isTourOpen = true;
        tourConfig.openTourJsCall(tourSteps, this.closeTour, this.props.language);
      }
      else {
        this.state.isTourOpen = false;
      }
    }

    // tour loading when later called
    if(prevState.isTourOpen==false && this.state.isTourOpen==true) {
        tourConfig.openTourJsCall(tourSteps, this.closeTour, this.props.language, ".main-container.scroll");
    }

    // feedback of canceled deviations
    if(prevProps.annulTasks.loading==true && this.props.annulTasks.loading==false) {
      if(this.props.annulTasks.status==200) {
        toastr.options = Constants.tostrOptions;
        toastr.success(
          this.props.language.tasks_manager.feedback.annulSuccess,
          ""
        );
        this.setState({
          pag: 1,
          annulStateMap: {}
        });

        await this.props.actions.fetchTasksManagerNoLoadingApi({
          dateStart: this.props.filtersTaskManager.date.fechaStartFinal,
          dateEnd: this.props.filtersTaskManager.date.fechaEndFinal,
          tags: this.props.filtersTaskManager.tags,
          personId: this.props.filtersTaskManager.personId,
          type: this.props.filtersTaskManager.type,
          subtype: this.props.filtersTaskManager.subtype,
          otherFilters: this.props.filters.otherFilters,
          sort: this.state.sort,
          pag: 1,
        });
        await this.props.dashboardActions.fetchTaskManagerIndicatorsApi();
      } else {
        toastr.options = Constants.tostrOptions;
        toastr.error(
          this.props.language.tasks_manager.feedback.annulError,
          ""
        );
      }
    }
    // edited deviation feedback
    if(prevProps.saveTask.loading==true && this.props.saveTask.loading==false) {
      if(this.props.saveTask.status==200) {
        toastr.options = Constants.tostrOptions;
        toastr.success(
          this.props.language.tasks_manager.feedback.editSuccess,
          ""
        );
        this.setState({
          showModal: false,
          showConfirmAnnulSingle: false,
          showConfirmAnnulSingleAction: null,
          pag: 1
        });

        await this.props.actions.fetchTasksManagerNoLoadingApi({
          dateStart: this.props.filtersTaskManager.date.fechaStartFinal,
          dateEnd: this.props.filtersTaskManager.date.fechaEndFinal,
          tags: this.props.filtersTaskManager.tags,
          personId: this.props.filtersTaskManager.personId,
          type: this.props.filtersTaskManager.type,
          subtype: this.props.filtersTaskManager.subtype,
          otherFilters: this.props.filters.otherFilters,
          sort: this.state.sort,
          pag: 1,
        });

        await this.props.dashboardActions.fetchTaskManagerIndicatorsApi();
      } else if(this.props.saveTask.status != 422) {
        const { message: saveTaskMessage, status: saveTaskStatus } = this.props.saveTask;
        let errorMessage = '';

        // if there is an error in the attached files, it shows a message
        if (saveTaskStatus === 500 && saveTaskMessage.error.code === '5200') {
          errorMessage = this.props.language.error.cod5200.replace('{list-extensions}', saveTaskMessage.error.params[0]);
          errorMessage = `<br/><br/><small>${errorMessage}</small>`;
        }

        toastr.options = Constants.tostrOptions;
        toastr.error(
          `${this.props.language.tasks_manager.feedback.editError} ${errorMessage}`,
          ''
        );

        this.setState({
          showModal: false,
          showConfirmAnnulSingle: false,
          showConfirmAnnulSingleAction: null
        });
      } else if(this.props.saveTask.status == 422) {
        var invalids = $(".task-generated-content .invalidInput");
        if(invalids.length>0) {
          invalids.get(0).scrollIntoView();
        }

        if(this.props.saveTask.message &&
          this.props.saveTask.message.error &&
          this.props.saveTask.message.error.params &&
          this.props.saveTask.message.error.params.find(param => param.messageCode == 18202)) {
          var error = this.props.saveTask.message.error.params.find(param => param.messageCode == 18202);
          var extraData = error && error.extraData ? error.extraData.find(data => data.key == "PersonAlias") : null
          this.setState({
            showDriverError: true,
            showDriverErrorAlias: extraData ? extraData.value : ""
          });
        }
      }
    }

    if (
      this.props.status === 200 &&
      this.props.statusTags === 200 &&
      this.state.paramTask
    ) {
      this.handleClickTask(this.state.paramTask);
    }
  }

  // Function performed to sort the table
  handleSort = async event => {
    // Change sort
    const sort = { ...this.state.sort };

    Object.keys(sort).forEach(function(key,index) {
      if(event.currentTarget.dataset.type !== key) {
        sort[key]=null;
      }
    });

    const value = this.state.sort[event.currentTarget.dataset.type] == 'DESC' ? 'ASC' : 'DESC';
    sort[event.currentTarget.dataset.type] = value;

    const date = this.props.filtersTaskManager.date;

    this.setState({ sort });
    this.setState({
      pag: 1,
      annulStateMap: {}
    });

    await this.props.actions.fetchTasksManagerNoLoadingApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags: this.props.filtersTaskManager.tags,
      personId: this.props.filtersTaskManager.personId,
      type: this.props.filtersTaskManager.type,
      subtype: this.props.filtersTaskManager.subtype,
      otherFilters: this.props.filters.otherFilters,
      sort,
      pag: 1,
    });
  };

  // Function performed to paginate
  handleScroll = async event => {
    if (!event.target.dataset.nonescroll && !this.state.isTourOpen) {
      if (!this.props.loadingTableSpiner) {
        if (this.state.pag < this.props.count.pages) {
          const scroll = event.target.scrollTop + 1000;
          const max = event.target.scrollHeight - event.target.offsetHeight;

          if (scroll >= max) {
            // Change Pag
            const pag = this.state.pag + 1;
            const date =  this.props.filtersTaskManager.date;

            this.setState({ pag: pag });

            await this.props.actions.fetchTasksManagerNoLoadingApi({
              dateStart: date.fechaStartFinal,
              dateEnd: date.fechaEndFinal,
              tags: this.props.filtersTaskManager.tags,
              personId: this.props.filtersTaskManager.personId,
              type: this.props.filtersTaskManager.type,
              subtype: this.props.filtersTaskManager.subtype,
              otherFilters: this.props.filters.otherFilters,
              sort: this.state.sort,
              pag,
              concat: true,
            });
          }
        }
      }
    }
  };

  handleModal = e => {
    e.stopPropagation();
    var showModal = this.state.showModal ? false : true;
    if (!showModal) {
      this.props.actions.resetTasksManagerTask();
    }
    this.setState({ showModal: showModal });
  };

  handleClickOutsideModal = e => {
    var target = $(e.target);
    if (
      !target.closest('.task-modal.container-modal-right').length && // Inside Modal
      e.target.nodeName != 'HTML' && // Page general scroll
      !target.closest('.module-table.top tbody tr').length &&
      !target.closest('.faults-detail-container-modal').length &&
      !target.closest('div:has(> .anullSingleAlert)').length &&
      !target.closest('.anullSingleAlert').length &&
      !target.closest('div:has(> .driverErrorAlert)').length &&
      !target.closest('.driverErrorAlert').length &&
      this.state.showModal
    ) {
      // Task table row
      this.handleModal(e);
    }
  };

  handleModalSlide = e => {
    var toHide = $('.slide-panel.show');
    var toShow = $('.slide-panel.hide');

    toHide.addClass('hide');
    toHide.removeClass('show');

    toShow.addClass('show');
    toShow.removeClass('hide');
  };

  handleClickTask = async (taskId) => {
    this.setState({ showModal: true, paramTask: null });
    await this.props.actions.fetchTasksManagerTaskApi({id: taskId});
  };

  handleAddAnnulTask = async (event) => {
    var id = event.target.dataset.id;
    const settings = JSON.parse(this.props.setting.value);
    var annuledSize = Object.keys(this.state.annulStateMap).length;

    if(id in this.state.annulStateMap) {
      delete this.state.annulStateMap[id];
    } else {
      if(annuledSize>=settings.taskManager.maxNumberOfAnnulments) {
        toastr.options = Constants.tostrOptions;
        toastr.error(
          this.props.language.tasks_manager.feedback.maxToAnnulReached,
          ""
        );
        return;
      }
      this.state.annulStateMap[id] = true;
    }

    this.setState({
      annulStateMap: this.state.annulStateMap
    });
  };

  handleAnnulTasks = async obj => {
    if(this.props.annulTasks.loading) {
      return;
    }

    var annuledSize = Object.keys(this.state.annulStateMap).length;

    if(annuledSize<=0) {
      toastr.options = Constants.tostrOptions;
      toastr.warning(
        this.props.language.tasks_manager.feedback.nothingSelectedToAnnul,
        ""
      );
      return;
    }
    this.setState({showConfirmAnnul:true});
  };

  handleAnnulTasksConfirm = async obj => {
    var idsArray = Object.keys(this.state.annulStateMap);
    await this.props.actions.annulTasksApi(idsArray);
    this.setState({
      showConfirmAnnul:false
    });
  };

  handleDownloadExcelSummary = async obj => {
    const dateStart = this.props.filtersTaskManager.date.fechaStartFinal;
    const dateEnd = this.props.filtersTaskManager.date.fechaEndFinal;

    // if there are errors, stop the execution
    const showErrorDownload = ObjGeneral.validateReportDownload(dateStart, dateEnd);

    // set the state
    this.handleShowErrorDownload(showErrorDownload);

    if (showErrorDownload) {
      return;
    }

    // if there are no errors, continue with the download process
    await this.props.actions.downloadSummaryReport({
      dateStart,
      dateEnd,
      tags: this.props.filtersTaskManager.tags,
      personId: this.props.filtersTaskManager.personId,
      type: this.props.filtersTaskManager.type,
      subtype: this.props.filtersTaskManager.subtype,
      otherFilters: this.props.filters.otherFilters,
      sort: this.state.sort
    });
  };

  handleDownloadExcelNoProcess = async obj => {
    const dateStart = this.props.filtersTaskManager.date.fechaStartFinal;
    const dateEnd = this.props.filtersTaskManager.date.fechaEndFinal;

    // if there are errors, stop the execution
    const showErrorDownload = ObjGeneral.validateReportDownload(dateStart, dateEnd);

    // set the state
    this.handleShowErrorDownload(showErrorDownload);

    if (showErrorDownload) {
      return;
    }

    // if there are no errors, continue with the download process
    await this.props.actions.downloadNoProcessReport({
      dateStart,
      dateEnd,
      tags: this.props.filtersTaskManager.tags,
      personId: this.props.filtersTaskManager.personId,
      type: this.props.filtersTaskManager.type,
      subtype: this.props.filtersTaskManager.subtype,
      otherFilters: this.props.filters.otherFilters,
      sort: this.state.sort
    });
  };

  handleShowErrorDownload = (showErrorDownload) => {
    this.setState({
      showErrorDownload
    });
  }

  handleOnChangeFormValue = e => {
    var targetId = e.target.id;
    var targetValue = e.target.value;

    if(e.target.files) {
      targetValue = e.target.files;
    } else if(e.target.dataset.groupid) {
      targetId = e.target.dataset.groupid;
      var groupValues = JSON.parse(e.target.dataset.groupvalue);
      if(e.target.checked) {
        groupValues.push(targetValue);
      } else {
        var newGroupValues = [];
        for(var i=0;i < groupValues.length;i++) {
          if(groupValues[i]!=targetValue) {
            newGroupValues.push(groupValues[i]);
          }
        }
        groupValues = newGroupValues;
      }
      targetValue = JSON.stringify(groupValues);
    }
    this.props.actions.handleChangeFormValue(targetId,targetValue);
  };

  handleModalHtmlPopup = async e => {
    if (e.target.dataset.close == 'ok-html-popup') {
      const reset = this.state.modalHtmlPopup ? false : true;
      this.setState({ modalHtmlPopup: reset });
      if (!reset) {
        this.setState({
          modalHtmlPopupData: {
            title: null,
            htmlDetail: null
          }
        });
      } else {
        const detail = e.target.dataset.detail;
        const title = e.target.dataset.title;

        this.setState({
          modalHtmlPopupData: {
            title: title,
            htmlDetail: detail
          }
        });
      }
    }
  };

  handleTaskActionConfirmFilter = (action) => {
    if (action == 'Annul') {
      this.setState({
        showConfirmAnnulSingle: true,
        showConfirmAnnulSingleAction: action
      });
    } else {
      this.handleTaskAction(action);
    }
  };

  handleTaskAction = async (action) => {
    action = this.state.showConfirmAnnulSingleAction ? this.state.showConfirmAnnulSingleAction : action;
    var files = [];
    var editedFields = [];
    var saveKeys = Object.keys(this.props.saveTask.datos);

    for(var i=0; i<saveKeys.length; i++) {
      var field = this.props.saveTask.datos[saveKeys[i]];
      if(field.isEditable) {
        editedFields.push({
          key: field.key,
          value: field.type == "File" ? null : field.value
        });
      }
      if(field.isEditable && field.type == "File" && typeof field.value == "object") {
        files = Object.keys(field.value).map( key => field.value[key]);
      }
    }

    var incidentDetail = {
      action: action,
      editedFields: editedFields
    };

    await this.props.actions.saveTaskApi(this.props.saveTask.id,incidentDetail,files);

    // tracks a Tasks Manager action event using Google Analytics.
    this.eventTracker.trackTasksManagerAction(action);
  };

  getOptionsEndpoint = async (fieldKey, endpoint) => {
    await this.props.actions.getFieldEnpointData({
      fieldKey: fieldKey,
      endpoint: endpoint
    });
  };

  getTaskFile = async (endpoint, filename) => {
    await this.props.actions.getTaskFile({
      endpoint: endpoint,
      filename: filename
    });
  };

  render() {
    if (this.props.setting) {
      // the setting object is obtained which we use for the configuration
      const obj = JSON.parse(this.props.setting.value);
      const rootUser = localStoreFN().getItem('root');
      const permits = localStoreFN().getItem('permits');

      let container = '';
      // condition performed for loading state of the view
      if (
        this.props.loading ||
        this.props.annulTasks.loading ||
        this.props.filtersTaskManager.loading
      ) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (
        this.props.status === 401 ||
        this.props.statusTags === 401 ||
        this.props.statusCount === 401 ||
        this.props.filtersTaskManager.status === 401
      ) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the success application
      } else if (
        this.props.status === 200 &&
        this.props.statusTags === 200 &&
        this.props.filtersTaskManager.status === 200
      ) {
        container = (
          <div className={`${this.props.containerClassName ? this.props.containerClassName : ''} scroll common-dashboards task-manager-container fix-bad-tour-position`}>
            <ButtonsTop
              typeTab={Constants.taskManagerTabs.TAB_TASKS}
              language={this.props.language ? this.props.language : ''}
              handleSubmit={this.handleSubmit}
              handleDownloadExcelSummary={this.handleDownloadExcelSummary}
              handleDownloadExcelNoProcess={this.handleDownloadExcelNoProcess}
              permits={permits}
              containerStyle={{ padding: 0 }}
              downloading={this.props.downloading}
            />
            <TopCharts
              typeTab={Constants.taskManagerTabs.TAB_TASKS}
              language={this.props.language ? this.props.language : ''}
              datos={this.props.datos.stats}
              containerStyle={{ margin: 0, marginBottom: '1rem' }}
            />
            <Filters
              typeTab={Constants.taskManagerTabs.TAB_TASKS}
              // the filters of the TaskManager component (parent) and of the current tab are sent
              filters={{
                ...this.props.filtersTaskManager,
                otherFilters: this.props.filters.otherFilters
              }}
              handleSubmit={this.handleSubmit}
              language={this.props.language ? this.props.language : ''}
              handleAnnulTasks={this.handleAnnulTasks}
              selectedAnnuls={Object.keys(this.state.annulStateMap).length}
              permits={permits}
              containerStyle={{ padding: 0 }}
            />
            <TasksTable
              typeTab={Constants.taskManagerTabs.TAB_TASKS}
              pag={this.state.pag}
              count={this.props.count}
              tooltip={this.props.language.tasks_manager.tooltip}
              datos={this.props.datos.tasks}
              title={this.props.language}
              language={this.props.language}
              handleSort={this.handleSort}
              loadingTable={this.props.loadingTableSpiner}
              sort={this.state.sort}
              handleClickTask={this.handleClickTask}
              handleAddAnnulTask={this.handleAddAnnulTask}
              annulCheckedTasks={this.state.annulStateMap}
              permits={permits}
              activeTask={this.props.activeTask}
              showOccurrenceDateExceptForAdminUsers={(obj.taskManager.showOccurrenceDateExceptForAdminUsers || rootUser=="true")}
              containerStyle={{ padding: 0 }}
            />
            <TaskModal
              typeTab={Constants.taskManagerTabs.TAB_TASKS}
              language={this.props.language}
              handleModal={this.handleModal}
              showModal={this.state.showModal}
              activeTask={this.props.activeTask}
              saveTask={this.props.saveTask}
              handleModalSlide={this.handleModalSlide}
              handleOnChange={this.handleOnChangeFormValue}
              handleModalHtmlPopup={this.handleModalHtmlPopup}
              handleTaskAction={this.handleTaskActionConfirmFilter}
              getOptionsEndpoint={this.getOptionsEndpoint}
              getTaskFile={this.getTaskFile}
            />
            <HtmlPopupModal
              handleModal={this.handleModalHtmlPopup}
              modal={this.state.modalHtmlPopup}
              language={this.props.language ? this.props.language : ''}
              title={this.state.modalHtmlPopupData.title}
              htmlDetail={this.state.modalHtmlPopupData.htmlDetail}
            />
            {this.state.showConfirmAnnul && (
              <SweetAlert
                error
                showCancel
                confirmBtnText={this.props.language.tasks_manager.annulConfirm.confirmButton}
                cancelBtnText={this.props.language.tasks_manager.annulConfirm.cancelButton}
                closeOnClickOutside={true}
                cancelBtnCssClass="cancel-buton-test"
                confirmBtnCssClass="confirm-button"
                title={
                  <span className="modal-title">
                    <strong>
                    {' '}
                    {this.props.language.tasks_manager.annulConfirm.question}
                    </strong>
                  </span>
                }
                onConfirm={this.handleAnnulTasksConfirm}
                onCancel={() => {this.setState({showConfirmAnnul:false});}}
              >
                <div className="tilte-modal-box">
                  {this.props.language.tasks_manager.annulConfirm.warning}
                </div>
              </SweetAlert>
            )}
            {this.state.showConfirmAnnulSingle && (
              <SweetAlert
                error
                showCancel
                confirmBtnText={this.props.language.tasks_manager.annulConfirm.confirmButton}
                cancelBtnText={this.props.language.tasks_manager.annulConfirm.cancelButton}
                closeOnClickOutside={true}
                cancelBtnCssClass="cancel-buton-test"
                confirmBtnCssClass="confirm-button"
                customClass={"anullSingleAlert"}
                title={
                  <span className="modal-title">
                    <strong>
                    {' '}
                    {this.props.language.tasks_manager.annulConfirm.questionSingle}
                    </strong>
                  </span>
                }
                onConfirm={this.handleTaskAction}
                onCancel={() => {
                  this.setState({
                    showConfirmAnnulSingle: false,
                    showConfirmAnnulSingleAction: null
                  });
                }}
              >
                <div className="tilte-modal-box">
                  {this.props.language.tasks_manager.annulConfirm.warningSingle}
                </div>
              </SweetAlert>
            )}
            {this.state.showDriverError && (
              <SweetAlert
                warning
                confirmBtnText={this.props.language.tasks_manager.driverErrorAlert.confirmButton}
                closeOnClickOutside={true}
                confirmBtnCssClass="confirm-button"
                customClass={"driverErrorAlert"}
                title={
                  <span className="modal-title">
                    <strong>
                    {' '}
                    {this.props.language.tasks_manager.driverErrorAlert.title}
                    </strong>
                  </span>
                }
                onConfirm={() => {this.setState({
                  showDriverError:false,
                  showDriverErrorAlias: ""
                });}}
                onCancel={() => {this.setState({
                  showDriverError:false,
                  showDriverErrorAlias: ""
                });}}
              >
                <div className="tilte-modal-box">
                  <p><strong>
                    {this.props.language.tasks_manager.driverErrorAlert.line1a + " "}
                    {this.state.showDriverErrorAlias}
                    {this.props.language.tasks_manager.driverErrorAlert.line1b}
                  </strong></p>
                  <p>
                    {this.props.language.tasks_manager.driverErrorAlert.line2}
                  </p>
                  <p><strong>
                    {this.props.language.tasks_manager.driverErrorAlert.line3}
                  </strong></p>
                </div>
              </SweetAlert>
            )}
            {this.state.showErrorDownload && (
                <SweetAlert
                  error
                  closeOnClickOutside={true}
                  confirmBtnCssClass="confirm-button"
                  title={
                    <span className="modal-title">
                      <strong>
                        {this.props.language.tasks_manager.excel.downloadErrorDateRangeTitle}
                      </strong>
                    </span>
                  }
                  onConfirm={() => this.handleShowErrorDownload(false)}
                >
                  <div className="tilte-modal-box">
                    {this.props.language.tasks_manager.excel.downloadErrorDateRangeDescription}
                  </div>
                </SweetAlert>
              )
            }
            <Tooltip placement="top" id="pageTooltip" />
            <Dialog
              title={this.props.language.tasks_manager.excel.downloadingTitle}
              modal={true}
              open={this.props.downloading}
            >
              <i className="fas fa-spinner fa-spin"></i> {this.props.language.tasks_manager.excel.downloadingPleaseWait}
            </Dialog>
          </div>
        );
      } else if (
        this.props.status === 500 ||
        this.props.statusTags === 500 ||
        this.props.statusCount === 500 ||
        this.props.filtersTaskManager.status === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section onScroll={this.handleScroll}>
          {container}
        </section>
      );
    }

    return (
      <section>
        <Message message="NO Setting" />
      </section>
    );
  }
}
const mapStateToProps = state => ({
  statusTags: state.reducer.tags.status,
  loadingFilter: state.reducer.tags.loading,

  setting: state.reducer.dashboard.setting,

  count: state.reducer.tasksManagerTabTasks.count,
  statusCount: state.reducer.tasksManagerTabTasks.statusCount,
  datos: state.reducer.tasksManagerTabTasks.datos,
  loading: state.reducer.tasksManagerTabTasks.loading,
  status: state.reducer.tasksManagerTabTasks.status,
  loadingTableSpiner: state.reducer.tasksManagerTabTasks.loadingTableSpiner,
  filters: state.reducer.tasksManagerTabTasks.filters,
  downloading: state.reducer.tasksManagerTabTasks.downloading,
  activeTask: state.reducer.tasksManagerTabTasks.activeTask,
  saveTask: state.reducer.tasksManagerTabTasks.saveTask,
  annulTasks: state.reducer.tasksManagerTabTasks.annulTasks,

  dateMax: state.reducer.dashboard.dateMax,
  language: state.reducer.dashboard.language,

  filtersTaskManager: state.reducer.tasksManager.filters
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tasksManagerTabTasksActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
  headerActions: bindActionCreators(headerActions, dispatch)
});
TasksManagerTabTasks.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TasksManagerTabTasks);



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/tasksManagerTabTasks.jsx